import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import styles from './confirmModal.module.css';

const ConfirmModal = ({
	isOpen,
	heading = 'Confirmation',
	IconComponent = WarningIcon,
	iconColor: fill = '#ffa500',
	iconFontSize: fontSize = 38,
	message = 'Please confirm you wish to proceed',
	width = '60%',
	maxWidth = 550,
	maxHeight = 300,
	showWithdraw = true,
	showProceed = true,
	withdrawButton = 'Back',
	proceedButton = 'Proceed',
	onProceed,
	onWithdraw
}) => {
	const useStyles = makeStyles(theme => ({
		paper: {
			width,
			maxWidth,
			maxHeight
		}
	}));
	const classes = useStyles();

	if (!isOpen) {
		return null;
	}

	return (
		<Dialog aria-labelledby="confirmation-dialog-title" classes={classes} open={isOpen}>
			<DialogTitle id="confirmation-dialog-title">
				<div className={styles.header}>
					<IconComponent style={{ fill, fontSize }} />
					<div className={styles.title}>
						<Typography variant="h6">{heading}</Typography>
					</div>
				</div>
			</DialogTitle>

			<DialogContent dividers>
				<div className={styles.body}>
					<Typography>{message}</Typography>
				</div>
			</DialogContent>

			<DialogActions>
				{showWithdraw && (
					<Button onClick={onWithdraw} className={styles.withdraw}>
						{withdrawButton}
					</Button>
				)}
				{showProceed && (
					<Button onClick={onProceed} className={styles.proceed}>
						{proceedButton}
					</Button>
				)}
			</DialogActions>
		</Dialog>
	);
};

ConfirmModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	heading: PropTypes.string,
	IconComponent: PropTypes.node,
	iconColor: PropTypes.string,
	iconFontSize: PropTypes.number,
	message: PropTypes.string,
	width: PropTypes.string,
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
	showWithdraw: PropTypes.bool,
	showProceed: PropTypes.bool,
	withdrawButton: PropTypes.string,
	proceedButton: PropTypes.string,
	onProceed: PropTypes.func,
	onWithdraw: PropTypes.func
};

export default ConfirmModal;
